import React, { FC } from 'react'

import {
  DeepPartial,
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFormRegister,
  UseFormWatch,
} from 'react-hook-form'

import { TextField, Txt } from 'src/components/atoms'
import { DateTxt, UserDetailBasicInfoContentItem, UserKeywordsForm } from 'src/components/molecules'

import {
  EditExternalUserBasicInfoFormEntity,
  EditUserBasicInfoFormEntity,
  ExternalUserEntity,
} from 'src/types'

type BaseProps = {
  externalUser: ExternalUserEntity
  isEditMode: boolean
  isUpdating: boolean
  className?: string
}
type BasicModeProps = { isEditMode: false }
type EditModeProps = {
  isEditMode: true
  register: UseFormRegister<EditExternalUserBasicInfoFormEntity>
  watch: UseFormWatch<EditExternalUserBasicInfoFormEntity>
  fields: FieldArrayWithId<DeepPartial<EditUserBasicInfoFormEntity>, 'keywords', 'id'>[]
  append: UseFieldArrayAppend<EditUserBasicInfoFormEntity, 'keywords'>
  remove: UseFieldArrayRemove
}
type Props = BaseProps & (BasicModeProps | EditModeProps)

export const ExternalUserDetailBasicInfoContent: FC<Props> = ({
  externalUser,
  isUpdating,
  isEditMode,
  className,
  ...otherProps
}) => {
  return (
    <div className={className}>
      <div>
        {isEditMode ? (
          <TextField
            {...(otherProps as EditModeProps).register('name')}
            className="tw-w-full"
            sizeType="l"
          />
        ) : (
          externalUser.name && (
            <Txt className="tw-break-all tw-font-bold !tw-text-s3">
              {isUpdating ? (otherProps as EditModeProps).watch('name') : externalUser.name}
            </Txt>
          )
        )}
        <Txt sizeType="l" className="tw-break-all tw-text-standardText-secondary tw-mt-s-2">
          {externalUser.email}
        </Txt>
      </div>
      <ul className="tw-grid tw-gap-s2 tw-mt-s2">
        <li>
          <UserDetailBasicInfoContentItem title="ID">
            <Txt sizeType="l">{externalUser.id}</Txt>
          </UserDetailBasicInfoContentItem>
        </li>
        <li>
          <UserDetailBasicInfoContentItem title="作成日">
            <DateTxt sizeType="l" date={externalUser.createdAt} withTime />
          </UserDetailBasicInfoContentItem>
        </li>
        <li>
          <UserDetailBasicInfoContentItem title="キーワード">
            {isEditMode ? (
              <UserKeywordsForm
                register={(otherProps as EditModeProps).register}
                fields={(otherProps as EditModeProps).fields}
                append={(otherProps as EditModeProps).append}
                remove={(otherProps as EditModeProps).remove}
                className="tw-w-full"
              />
            ) : (
              <Txt sizeType="l" className="tw-break-all">
                {externalUser.keywords.length > 0 ? externalUser.keywords.join(', ') : '-'}
              </Txt>
            )}
          </UserDetailBasicInfoContentItem>
        </li>
      </ul>
    </div>
  )
}
